import { apiClient } from '@/services/api/axiosClient';
import { endpoints } from '@/services/api/apiEndpoints';

export interface NotificationDto {
  notificationId: number;
  type: string;
  title: string;
  message: string;
  isRead: boolean;
  createdAt: string;
}

export const notificationsApi = {
  list: async (): Promise<NotificationDto[]> => {
    const { data } = await apiClient.get(endpoints.notifications.list);
    return data;
  },
  markRead: async (id: number): Promise<void> => {
    await apiClient.post(endpoints.notifications.markRead(id));
  },
};
